import { UserAction, UserActionType } from '../actions/user';
import { UserInstrument } from '../models/user';

export interface UserNamespace {
    userInstruments: Array<UserInstrument>;
}

export interface WithUserNamespace {
    user?: UserNamespace;
}

export const userReducer = (
    state: UserNamespace = {
        userInstruments: [],
    },
    action: UserAction,
): UserNamespace => {
    switch (action.type) {
        case UserActionType.updateUserInstruments:
            return {
                ...state,
                userInstruments: action.payload,
            };

        default:
            return state;
    }
};
